'use strict';
define(['angular'], function (angular) {
    function Controller($scope, $stateParams, $state, $mdDialog, $timeout, $interval, $translate, SERPChecker, LanguageService, $window, UserService, CountriesService) {
        var vm = $scope;
        var serpSceneIndex = 0;
        var serpSceneTimer = null;
        var serpSceneInterval = null;
        var serpSceneTimeouts = [];
        var serpSceneOrder = ['serp', 'compare', 'insights'];
        var serpSceneDurations = {serp: 4300, compare: 4800, insights: 5100};
        var reducedMotion = !!($window.matchMedia && $window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        vm.devicesAvailable = SERPChecker.config.devicesAvailable;
        vm.expandSection = false;
        vm.query = {
            mode: getCurrentMode() || 'backlink',
            keyword: $stateParams.keyword || null,
            keywordDraft: $stateParams.keyword || '',
            deviceId: parseInt($stateParams.deviceId, 10) || SERPChecker.config.defaultDeviceId,
            searchEngineId: SERPChecker.config.defaultSearchEngineId,
            countryCode: $stateParams.countryCode || LanguageService.getCountryCodeSaveOnStorage() || 'US',
            benchmark: getBenchmarkFromStateParams() || []
        };
        vm.countryOptions = CountriesService.all();
        vm.countryPickerSearch = {query: ''};
        vm.selectedDevice = null;
        vm.selectDevice = selectDevice;
        vm.selectCountry = selectCountry;
        vm.filterCountry = filterCountry;
        syncSelectedDevice();
        syncSelectedCountry();

        vm.newAnalysis = newAnalysis;
        vm.editCompetitors = editCompetitors;
        vm.cleanUrl = cleanUrl;
        updateLimit();

        vm.currentActiveTab = 0;
        switch (getCurrentMode()) {
            default:
            case 'backlink':
                vm.currentActiveTab = 0;
                break;
            case 'copywriting':
                vm.currentActiveTab = 1;
                break;
        }

        vm.linkTabs = [{
            label: 'serpchecker.backlink.data',
            labelXs: 'Backlink',
            icon: 'ti-affiliate',
            isActive: getCurrentMode() === 'backlink',
        }, {
            label: 'serpchecker.copywriting.strategies',
            labelXs: 'Copywriting',
            icon: 'ti-writing',
            isActive: getCurrentMode() === 'copywriting',
        }];
        vm.serpModeOptions = [
            {value: 0, label: 'Backlink', icon: 'ti ti-affiliate'},
            {value: 1, label: 'Copywriting', icon: 'ti ti-writing'}
        ];

        vm.serpLandingScene = 'serp';
        vm.serpLandingScenes = [
            {id: 'serp', key: 'serpchecker.landing.scene.serp'},
            {id: 'compare', key: 'serpchecker.landing.scene.compare'},
            {id: 'insights', key: 'serpchecker.landing.scene.insights'}
        ];
        vm.serpLandingTypedText = '';
        vm.serpLandingTyping = false;
        vm.serpLandingStarted = false;
        vm.serpLandingProgress = 0;
        vm.serpLandingResults = [
            {rank: 1, domain: 'nike.com', title: 'serpchecker.landing.preview.result1', strength: 94, visible: false},
            {rank: 2, domain: 'runnersworld.com', title: 'serpchecker.landing.preview.result2', strength: 87, visible: false},
            {rank: 3, domain: 'strava.com', title: 'serpchecker.landing.preview.result3', strength: 81, visible: false}
        ];
        vm.serpLandingCompetitors = [
            {rank: '#1', domain: 'nike.com', label: 'serpchecker.landing.compare.leader', authority: 92, content: 88, visible: false, isYou: false},
            {rank: '#2', domain: 'runnersworld.com', label: 'serpchecker.landing.compare.publisher', authority: 86, content: 83, visible: false, isYou: false},
            {rank: '#3', domain: 'strava.com', label: 'serpchecker.landing.compare.platform', authority: 79, content: 74, visible: false, isYou: false},
            {rank: '#8', domain: 'il-tuo-sito.com', label: 'serpchecker.landing.compare.yourSite', authority: 41, content: 62, visible: false, isYou: true}
        ];

        vm.selectSerpLandingScene = selectSerpLandingScene;
        if (!vm.query.keyword) {
            startSerpLandingPreview();
        }
        $window.document.addEventListener('visibilitychange', handleSerpVisibilityChange);

        vm.setActiveTab = function (tabIndex) {
            vm.currentActiveTab = tabIndex;
            switch (tabIndex) {
                default:
                case 0:
                    vm.query.mode = 'backlink';
                    break;
                case 1:
                    vm.query.mode = 'copywriting';
                    break;
            }
            //newAnalysis();
        };

        function updateLimit() {
            UserService.limits()
                .then(function (res) {
                    if (res && res.data && res.data.limits) {
                        vm.analysisLimit = res.data.limits.find(function (service) {
                            return service.alias === 'analysis';
                        });
                    }

                })
                .catch(function (err) {
                    console.error(err);
                    return null;
                });
        }

        function selectCountry(country) {
            if (!country) {
                return;
            }
            vm.selectedCountry = country;
            vm.query.countryCode = country.code;
            vm.countryPickerSearch.query = '';
        }

        function selectDevice(device) {
            if (!device) {
                return;
            }
            vm.selectedDevice = device;
            vm.query.deviceId = device.id;
        }

        function syncSelectedDevice() {
            vm.selectedDevice = vm.devicesAvailable.find(function (device) {
                return device.id === vm.query.deviceId;
            }) || vm.devicesAvailable[0];
        }

        function filterCountry(country) {
            var query = (vm.countryPickerSearch.query || '').trim().toLowerCase();
            if (!query) {
                return true;
            }
            return String(country.name || '').toLowerCase().indexOf(query) !== -1
                || String(country.code || '').toLowerCase().indexOf(query) !== -1;
        }

        function syncSelectedCountry() {
            vm.selectedCountry = vm.countryOptions.find(function (country) {
                return country.code === vm.query.countryCode;
            }) || {
                name: vm.query.countryCode,
                code: vm.query.countryCode
            };
        }

        function startSerpLandingPreview() {
            if (reducedMotion) {
                showSerpLandingFinalState();
                return;
            }
            clearSerpLandingTimers();
            serpSceneTimeouts.push($timeout(function () {
                playSerpLandingScene(serpSceneIndex);
            }, 320));
        }

        function handleSerpVisibilityChange() {
            if ($window.document.hidden) {
                clearSerpLandingTimers();
            } else if (!vm.query.keyword && !reducedMotion) {
                playSerpLandingScene(serpSceneIndex);
            }
        }

        function selectSerpLandingScene(index) {
            if (vm.query.keyword) {
                return;
            }
            playSerpLandingScene(index);
        }

        function playSerpLandingScene(index) {
            clearSerpLandingTimers();
            serpSceneIndex = index % serpSceneOrder.length;
            vm.serpLandingScene = serpSceneOrder[serpSceneIndex];
            resetSerpLandingPreview();

            if (vm.serpLandingScene === 'serp') {
                runSerpLandingSearch();
            } else if (vm.serpLandingScene === 'compare') {
                runSerpLandingComparison();
            }

            serpSceneTimer = $timeout(function () {
                playSerpLandingScene(serpSceneIndex + 1);
            }, serpSceneDurations[vm.serpLandingScene]);
        }

        function resetSerpLandingPreview() {
            cancelSerpSceneInterval();
            vm.serpLandingTypedText = '';
            vm.serpLandingTyping = false;
            vm.serpLandingStarted = false;
            vm.serpLandingProgress = 0;
            vm.serpLandingResults.forEach(function (result) {
                result.visible = false;
            });
            vm.serpLandingCompetitors.forEach(function (competitor) {
                competitor.visible = false;
            });
        }

        function runSerpLandingSearch() {
            var target = $translate.instant('serpchecker.landing.preview.query');
            var position = 0;
            vm.serpLandingTyping = true;
            serpSceneInterval = $interval(function () {
                position = Math.min(position + 1, target.length);
                vm.serpLandingTypedText = target.slice(0, position);
                if (position >= target.length) {
                    cancelSerpSceneInterval();
                    vm.serpLandingTyping = false;
                    serpSceneTimeouts.push($timeout(function () {
                        vm.serpLandingStarted = true;
                        runSerpLandingProgress();
                    }, 180));
                }
            }, 48);
        }

        function runSerpLandingProgress() {
            var started = Date.now();
            var duration = 2100;
            var thresholds = [12, 36, 58];
            serpSceneInterval = $interval(function () {
                var t = Math.min((Date.now() - started) / duration, 1);
                var eased = t * t * (3 - 2 * t);
                vm.serpLandingProgress = Math.round(eased * 100);
                vm.serpLandingResults.forEach(function (result, index) {
                    result.visible = vm.serpLandingProgress >= thresholds[index];
                });
                if (t >= 1) {
                    cancelSerpSceneInterval();
                }
            }, 50);
        }

        function runSerpLandingComparison() {
            vm.serpLandingCompetitors.forEach(function (competitor, index) {
                serpSceneTimeouts.push($timeout(function () {
                    competitor.visible = true;
                }, 180 + index * 270));
            });
        }

        function showSerpLandingFinalState() {
            vm.serpLandingScene = 'serp';
            vm.serpLandingTypedText = $translate.instant('serpchecker.landing.preview.query');
            vm.serpLandingTyping = false;
            vm.serpLandingStarted = true;
            vm.serpLandingProgress = 100;
            vm.serpLandingResults.forEach(function (result) {
                result.visible = true;
            });
            vm.serpLandingCompetitors.forEach(function (competitor) {
                competitor.visible = true;
            });
        }

        function cancelSerpSceneInterval() {
            if (serpSceneInterval) {
                $interval.cancel(serpSceneInterval);
                serpSceneInterval = null;
            }
        }

        function clearSerpLandingTimers() {
            cancelSerpSceneInterval();
            if (serpSceneTimer) {
                $timeout.cancel(serpSceneTimer);
                serpSceneTimer = null;
            }
            serpSceneTimeouts.forEach(function (timer) {
                $timeout.cancel(timer);
            });
            serpSceneTimeouts.length = 0;
        }


        function getBenchmarkFromStateParams() {
            var stateParamsBenchmark = [];
            if ($stateParams.benchmark && isString($stateParams.benchmark))
                stateParamsBenchmark = [$stateParams.benchmark];
            if ($stateParams.benchmark && !isString($stateParams.benchmark) && $stateParams.benchmark.length)
                stateParamsBenchmark = $stateParams.benchmark;
            return stateParamsBenchmark;
        }

        function editCompetitors(ev) {
            $mdDialog.show({
                templateUrl: "app/modules/serpchecker/dialogs/edit-competitors/edit-competitors.html",
                controller: "SerpCheckerEditCompetitorsCtrl",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                preserveScope: true,  // do not forget this if use parent scope
                locals: {benchmark: vm.query.benchmark}
            }).then(function (benchmark) {
                vm.query.benchmark = benchmark;
                vm.$broadcast("SERPCheckerAuditCompetitors", vm.query);
                updateStateUsingParams(false);
            });
        }

        function removeCompetitor(evt, index) {
            if (index === null) {
                vm.query.benchmark = [];
            } else {
                vm.query.benchmark.splice(index, 1);
            }
            updateStateUsingParams(false);
        }

        function newAnalysis() {
            var keyword = (vm.query.keywordDraft || '').trim();
            if (!keyword) {
                return;
            }
            vm.query.keyword = keyword;
            vm.query.keywordDraft = keyword;
            vm.$broadcast("SERPCheckerAudit", vm.query);
            updateStateUsingParams();
            updateLimit();
        }

        function updateStateUsingParams(notify = true) {
            switch (vm.query.mode) {
                case 'social':
                    $state.go('app.serpchecker.tool.benchmark.social', vm.query, {
                        notify: notify,
                        reload: 'app.serpchecker.tool.benchmark'
                    });
                    break;
                case 'seo':
                    $state.go('app.serpchecker.tool.benchmark.seo', vm.query, {
                        notify: notify,
                        reload: 'app.serpchecker.tool.benchmark'
                    });
                    break;
                case 'copywriting':
                    $state.go('app.serpchecker.tool.benchmark.copywriting', vm.query, {
                        notify: notify,
                        reload: 'app.serpchecker.tool.benchmark'
                    });
                    break;
                default:
                    $state.go('app.serpchecker.tool.benchmark.backlink', vm.query, {
                        notify: notify,
                        reload: 'app.serpchecker.tool.benchmark'
                    });
                    break;
            }
        }

        function cleanUrl(url) {
            url = url.replace('https://', '');
            url = url.replace('http://', '');
            url = url.replace('www.', '');
            url = url.replace(/^www\./i, '');
            url = url.replace(/\/$/i, '');
            return url.trim();
        }

        function getCurrentMode() {
            try {
                return $state.current.name.replace(/.*\./, '');
            } catch (e) {
                return 'backlink';
            }
        }

        /* utilities */
        function isString(value) {
            return typeof value === 'string';
        }

        vm.$watch('query.mode', function (newMode, oldMode) {
            var isModeChanged = newMode !== oldMode;
            if (isModeChanged) {
                newAnalysis();
            }
        });
        vm.$watch('query.keyword', function (keyword) {
            if (keyword) {
                clearSerpLandingTimers();
            } else if (!vm.query.keyword) {
                startSerpLandingPreview();
            }
        });
        vm.$on('$destroy', function () {
            $window.document.removeEventListener('visibilitychange', handleSerpVisibilityChange);
            clearSerpLandingTimers();
        });
        vm.$on('SERPCheckerOnCompetitorsChanged', removeCompetitor);
    }

    Controller.$inject = ['$scope', '$stateParams', '$state', '$mdDialog', '$timeout', '$interval', '$translate', 'SerpCheckerService', 'LanguageService', '$window', 'UserService', 'CountriesService'];
    return Controller;
});
